import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=62e3192b&"
import script from "./CustomerDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Volumes/ExSSD/projects/oee/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../Volumes/ExSSD/projects/oee/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VContainer,VDataTable,VFlex,VLayout,VSelect,VSwitch,VTextField})
